import { isEmpty } from 'lodash';

const getBrandsResponse = (data) => {
    if (isEmpty(data)) return [];

    return data;
};

export default getBrandsResponse;
